const setInstanceStatus = (instance) => {
    if (!instance["container-info"]) {
        instance["status"] = "stopped"
        return instance;
    }

    const serviceCount = {
        "dashboard": 0,
        "renderer": 0,
        "scheduler": 0,
        "pirana": 0
    }

    instance["container-info"].services.forEach((service) => {
        const serviceName = service.serviceName.split('-')[0]
        if (service.runningCount >= 1) {
            serviceCount[serviceName] += 1
        }
    })

    if (serviceCount.dashboard >= 1) {
        instance["status"] = "running"
    } else {
        instance["status"] = "stopped"
    }

    return instance;
}

const linkJobToInstance = (pisaasInstances, scheduledJobs) => {
    return scheduledJobs.map((job) => {
        const serviceName = pisaasInstances.find((instance) => instance["pisaas_instance_id"] === job["pisaas_instance_id"])
        job["service_name"] = serviceName?.domain || "";
        return job;
    })
}

export {setInstanceStatus, linkJobToInstance}